import type { BotType } from "./BotType.js";
import type { Ruleset } from "./Ruleset.js";


export class Bot {

    private readonly type: BotType;
    private readonly settings: Ruleset;

    constructor(type: BotType, settings: Ruleset) {
        this.type = type;
        this.settings = settings;
    }

    getType(): BotType {
        return this.type;
    }

    getSettings(): Ruleset {
        return this.settings;
    }
}
